import axios from 'axios'
import {authHeaders} from './authorize'
import {getCookie, setCookie} from 'tiny-cookie';

/**
 * Create a service functions that takes (data) or if paramater is passed, (arg, data)
 * and returns an axios promise.
 * When using static urls for development, these are get requests
 * and params/data is ignored.
 * All of these services will send authorization headers (possibly waiting
 * for the authorization service to respond)
 */
export default function defineService(method, path, options) {
  if (options && options.alternatives) {
    // Save all possible alternatives for use in UI
    for (let key in options.alternatives) ALL_ALTERNATIVES[key] = false;
  }
  if (URLS.STATIC) {
    return async data => getStatic(URLS.API + path, method, options, data)
  } else {
    return async (...args) => {
      const url = URLS.API + expandAndRemoveArgs(path, args);
      return callService(url, method, args[0], options);
    }
  }
}
export const ALL_ALTERNATIVES = {};

/**
 * To facilitate testing, allow the static file to be returned to change.
 *
 * Any flags (defined in the flags cookie) that match an alternative passed
 * in defineService will cause that suffix to be added to the static request URL.
 * Without a mechanism like this, it would be impossible to test all UI states
 * from the `npm run dev`
 *
 * If the suffix ends in a status code (with dash), eg '-wrongpw-400', then that status
 * code is faked as well.
 *
 * @param {string} options -- object containing staticIds, alternatives, suffix
 *
 */
function staticTweaks(options, data) {
  let {suffixFunc=calcSuffix, alternatives={}} = options || {};
  let flags = getCookie('flags', JSON.parse);
  let suffix = suffixFunc(data, flags || {}, alternatives) || '';
  let m = /-([45]\d\d)$/.exec(suffix);
  return {suffix, status: m && m[1]};
}

function calcSuffix(data, flags, alternatives) {
  if (!alternatives) return;
  for (let alternativeKey in alternatives) {
    if (flags[alternativeKey]) {
      return alternatives[alternativeKey];
    }
  }
}

async function getStatic(url, method, options, args) {
  let {suffix, status} = staticTweaks(options, args);
  let response = await axios.get(url + method + suffix + '.json');
  if (status) throw fakeAxiosError(status, response);
  return extractResult(response, options);
}

function fakeAxiosError(status, response) {
  let e = new Error('fake error');
  response.status = status;
  e.response = response;
  return e;
}

async function callService(url, method, data, options) {
  var headers = addContentType(await authHeaders(), data);
  return axios({url, method, headers, [method === 'get' ? 'params' : 'data']: data}).then(response => extractResult(response, options))
}

function extractResult(response, options) {
  var data = response.data
  if (options && options.mainKey) data = data[options.mainKey]
  return data
}

function addContentType(headers, data) {
  if (data instanceof FormData) {
    headers['content-type'] = 'multipart/form-data';
  } else if (data) {
    headers['content-type'] = 'application/json';
  }
  return headers;
}

function expandAndRemoveArgs(url, args) {
  if (args[0] && isUrl(args[0])) {
    return expandFromUrl(url, args.shift());
  } else {
    return url.replace(/:([a-z]+)/g, (m) => args.shift());
  }
}

function isUrl(arg) {
  return typeof(arg) === 'string' && arg.startsWith('http');
}

function expandFromUrl(urlPattern, expandedUrl) {
  // Turn parameters in urlPattern into a regex matching numbers
  var re = new RegExp(urlPattern.replace(/(:[a-z]+)/g, '[0-9]+'));
  // Return the portion that matches (or fail)
  var match = re.exec(expandedUrl);
  if (!match) throw new Error("Unable to match url: "+JSON.stringify({urlPattern, expandedUrl}));
  return match[0];
}



// WEBPACK FOOTER //
// ./src/services/defineService.js